import React from 'react';
import Dashboard from '../../components/Dashboard';
import MenuContainer from '../../components/custom-components/menu/MenuContainer';
import AdaptiveContainer from '../../components/containers/AdaptiveContainer';
import SubscriptionComponent from '../../components/page-components/subscription/SubscriptionComponent';
import { GetAdditionalProducts } from '../../graphql/queries/GetAdditionalProducts';

import { GetCurrentSubscriptionInfo } from '../../graphql/queries/GetCurrentSubscriptionInfo';
import { useQuery } from '@apollo/client';
import { useError } from '../../error-provider/ErrorProvider';
import { useRequireSubscription } from '../../hooks/useRequireSubscription';

const Subscription = () => {
    const { showError } = useError();
    const { data: subData, loading: subLoading } = useQuery(GetCurrentSubscriptionInfo, {
        onError(error) {
            showError(undefined, error);
        },
    });
    const { data: minutesData, loading: minutesLoading } = useQuery(GetAdditionalProducts, {
        onError(error) {
            showError(undefined, error);
        },
    });

    // Redirect if user has no subscription
    useRequireSubscription();

    const mainStyles = {
        '@media only screen and (min-width: 465px)': {
            width: '96%',
        },
        '@media only screen and (min-width: 1300px)': {
            width: '90%',
        },
        '@media only screen and (max-width: 450px)': {
            width: '90%',
        },
        '@media only screen and (max-height: 375px)': {
            width: '660px',
        },
    };

    return (
        <Dashboard title='dashboard'>
            <MenuContainer>
                <AdaptiveContainer css={{ ...mainStyles }}>
                    <SubscriptionComponent
                        subData={subData}
                        minutesData={minutesData}
                        minutesLoading={minutesLoading}
                        subLoading={subLoading}
                    />
                </AdaptiveContainer>
            </MenuContainer>
        </Dashboard>
    );
};

export default Subscription;
